// FIXME: 組織のポリシー: Frontend（このファイル）で直指定している
import { isAdmin, isMember } from '@/policies/';
var company = {
    index: function () {
        return true;
    },
    show: function () {
        return true;
    },
    update: function (company) {
        return isAdmin(company.user_type) || isMember(company.user_type);
    }
};
export default company;
